import * as React from 'react';
import { ArrowLeft, Close, Icon } from '@components/atoms';
import { cn } from '@utils';

type NavigationBarProps = {
	goBack?: () => void;
	onCancel?: () => void;
	layout?: React.CSSProperties['justifyContent'];
	height?: React.CSSProperties['height'];
};

export const NavigationBar: React.FC<NavigationBarProps> = ({
	goBack,
	onCancel,
	layout = !goBack && onCancel ? 'flex-end' : 'space-between',
	height = 24,
}) => {
	if (!goBack && !onCancel) {
		return null;
	}

	return (
		<div
			className={cn(' flex w-full px-[16px] text-secondary [&>svg]:cursor-pointer')}
			style={{ justifyContent: layout, height }}
		>
			{goBack && <ArrowLeft height={24} width={24} onClick={goBack} data-testid="navigation-bar-back-button" />}
			{onCancel && (
				<Close height={24} width={24} onClick={onCancel} style={{}} data-testid="navigation-bar-close-button" />
			)}
		</div>
	);
};
